import { ReactNode } from 'react'
import {
	Button,
	Dialog as AriaDialog,
	Modal,
	ModalRenderProps,
	ModalOverlay,
	Heading,
	ModalOverlayProps,
	DialogProps,
} from 'react-aria-components'

const overlayStyles = {
	base: 'fixed inset-0 bg-gray-400/50 grid place-items-center',
	isEntering: 'animate-in fade-in duration-200 ease-out',
	isExiting: 'bg-transparent pointer-events-none',
}

const modalStyles = {
	base: 'min-w-[480px] fixed index-0 bg-white shadow-xl animate-in fade-in slide-in-from-bottom-1 ease-out duration-200',
	isEntering: 'animate-in slide-in-from-bottom-1 ease-out duration-200',
	isExiting: 'animate-out slide-out-to-bottom-1 ease-in duration-100',
}

const className =
	(styles: typeof modalStyles) =>
	({ isEntering, isExiting }: ModalRenderProps) =>
		`${styles.base} ${isEntering ? styles.isEntering : ''} ${isExiting ? styles.isExiting : ''}`

export function Dialog({
	children,
	heading,
	...props
}: Omit<ModalOverlayProps, 'children'> & Pick<DialogProps, 'children'> & { heading: ReactNode }) {
	return (
		<ModalOverlay className={className(overlayStyles)} isDismissable {...props}>
			<Modal className={className(modalStyles)}>
				<AriaDialog className="outline outline-0 w-full max-h-[90vh] flex flex-col">
					{({ close }) => (
						<>
							<Heading
								slot="title"
								className="bg-gray-50 border-b border-gray-200 p-4 text-lg flex-none"
							>
								{heading}
							</Heading>
							<Button
								onPress={close}
								className="absolute top-2 right-[100%] rounded-l-lg bg-slate-900 text-xs text-slate-50 p-3 leading-none"
								aria-label="Zavřít"
							>
								╳
							</Button>
							<div className="overflow-auto">
								{typeof children === 'function' ? children({ close }) : children}
							</div>
						</>
					)}
				</AriaDialog>
			</Modal>
		</ModalOverlay>
	)
}

export function DialogFooter({ children }: { children: ReactNode }) {
	return (
		<div className="bg-gray-50 border-t border-gray-200 p-4 flex-none flex justify-between items-center">
			{children}
		</div>
	)
}
